export const DEFAULT_JOURNEY_ID = '00000000-0000-0000-0000-000000000000';


// WEBPACK FOOTER //
// ./source/ts/constants/journey.ts